<div class="card position-relative">
  @if (isLoading) {
    <loader [config]="{ type: 'spinner', overlay: true, size: 'md' }"></loader>
  }

  <div class="card-header d-flex justify-content-between align-items-center gap-2">
    <div class="d-flex align-items-center gap-2">
      <h3 class="card-title mb-0">VLT Dashboard</h3>
      @if (vlt) {
        <span class="badge bg-primary-subtle text-primary text-uppercase vlt-code-badge">{{ vlt.code }}</span>
      }
    </div>
    @if (vlt && canModify) {
      <button type="button" class="btn btn-primary" (click)="editVlt()">
        <i class="fa fa-edit me-1"></i>Edit
      </button>
    }
  </div>

  <div class="card-body">
    <regulator-context-box [items]="contextItems" (back)="goBack()" />

    @if (vlt) {
      <div class="row g-3 mb-4">
        <div class="col-xl-3 col-sm-6">
          <div class="vlt-indicator">
            <span class="vlt-indicator-label">Status</span>
            <span [class]="statusBadgeClass(vlt.status) + ' vlt-indicator-badge'">{{ statusLabel(vlt.status) }}</span>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6">
          <div class="vlt-indicator">
            <span class="vlt-indicator-label">Last Seen</span>
            <span class="vlt-indicator-value">{{ formatDateTime(vlt.lastSeenTime) }}</span>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6">
          <div class="vlt-indicator">
            <span class="vlt-indicator-label">Venue</span>
            <span class="vlt-indicator-value">{{ vlt.venue || '-' }}</span>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6">
          <div class="vlt-indicator">
            <span class="vlt-indicator-label">City</span>
            <span class="vlt-indicator-value">{{ vlt.city || '-' }}</span>
          </div>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-xl-7">
          <div class="vlt-panel h-100">
            <div class="vlt-panel-header">
              <h4 class="vlt-panel-title"><i class="bi bi-geo-alt me-2"></i>Location</h4>
              @if (mapExternalUrl) {
                <a class="btn btn-sm btn-outline-primary" [href]="mapExternalUrl" target="_blank" rel="noopener noreferrer">
                  Open map<i class="bi bi-box-arrow-up-right ms-1"></i>
                </a>
              }
            </div>
            @if (mapEmbedUrl) {
              <iframe class="vlt-map" [src]="mapEmbedUrl" [title]="'Map of ' + vlt.code" loading="lazy"></iframe>
            } @else {
              <div class="vlt-map-empty">
                <i class="bi bi-geo-alt"></i>
                <p class="mb-0">Geographic position not available</p>
              </div>
            }
          </div>
        </div>
        <div class="col-xl-5">
          <div class="vlt-panel h-100">
            <div class="vlt-panel-header">
              <h4 class="vlt-panel-title"><i class="bi bi-info-circle me-2"></i>Details</h4>
            </div>
            <data-list [config]="detailsConfig" />
          </div>
        </div>
      </div>
    }
  </div>
</div>
